import { DeleteOutlined } from '@mui/icons-material';
import { Button, Dialog, DialogActions, DialogContent, DialogTitle } from '@mui/material';
import type { FC } from 'react';

import ConfirmationDialog from 'components/v2/common/confirmationDialog';
import Result from 'components/v2/common/Result';

import useTranslate from 'hooks/useTranslate';

export interface RemoveApplicationDialogProps {
    clientView: boolean;
    selectedApps: number[];
    loading?: boolean;
    onClose: () => void;
    onConfirm: () => void | Promise<void>;
}

export const RemoveApplicationDialog: FC<RemoveApplicationDialogProps> = ({
    clientView,
    selectedApps,
    loading = false,
    onClose,
    onConfirm,
}) => {
    const { translate } = useTranslate();
    const canDelete = clientView || selectedApps.length > 0;

    if (canDelete) {
        return (
            <ConfirmationDialog
                title={translate('removeCase')}
                content={`${translate('areYouSureDeleteApp')} ${translate('thisCannotBeUndone')}!`}
                loading={loading}
                onClose={onClose}
                onConfirm={onConfirm}
            />
        );
    }

    return (
        <Dialog open fullWidth maxWidth="xs" onClose={onClose} scroll="paper">
            <DialogTitle>{translate('removeCase')}</DialogTitle>
            <DialogContent>
                <Result
                    icon={<DeleteOutlined sx={{ fontSize: 32 }} />}
                    title={translate('selectAppFirst')}
                    description={translate('selectAppFirstDescription')}
                />
            </DialogContent>
            <DialogActions sx={{ px: 3, py: 2, gap: 1 }}>
                <Button variant="outlined" onClick={onClose} sx={{ textTransform: 'none' }}>
                    {translate('close')}
                </Button>
            </DialogActions>
        </Dialog>
    );
};
